import {
  HeaderCard,
  ListPlan,
  ListPlanContent,
  CardPrincing,
  ContentIconListPlan,
} from '../pricingPage.style';
import { Box, Typography } from '@mui/material';
import { saasModernTheme } from 'common/theme/saasModern';
import CheckIcon from '@mui/icons-material/Check';
import { gradientBoxStyleWithHoverAnimation } from 'utils/gradianStyle';
import STGradiantButton from 'common/STGradiantButton/STGradiantButton';
import PriceDisplay from '../PriceDisplay/PriceDisplay';
import STGradiantChip from 'common/STGradiantChip/STGradantChip';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslations } from 'hooks/useTranslations';
const EnterpriseHeader = ({ subscription }) => {
  const { t } = useTranslations();
  const handleClick = (event) => {
    event.preventDefault();
    window.open(
      'https://www.swiftask.ai/contact-us',
      '_blank',
      'noopener,noreferrer',
    );
  };
  return (
    <>
      <HeaderCard>
        <Typography
          fontWeight={900}
          textTransform={'none'}
          sx={{
            color: saasModernTheme.colors.black,
            fontSize: '24px',
          }}
        >
          {subscription.name}
        </Typography>
        <STGradiantChip
          disabled
          variant="outlined"
          label={'Enterprise'}
          sx={{
            fontSize: '14px',
            fontWeight: '700',
            height: '24px',
            ml: 'auto',
            color: saasModernTheme.colors.black,
            textTransform: 'uppercase',
          }}
        />
      </HeaderCard>
      <Box
        component="div"
        sx={{
          fontWeight: '700',
          display: 'flex',
          width: '100%',
          minHeight: 40,
          gap: 6,
          my: 2,
        }}
      >
        <Typography
          variant="h6"
          mt={0.5}
          sx={{
            fontWeight: '500',
            fontSize: '16px',
            color: saasModernTheme.colors.black,
          }}
        >
          {t('pricing.tailor.description')}
        </Typography>
      </Box>
      <STGradiantButton
        fullWidth
        onClick={handleClick}
        size="small"
        label={t('pricing.tailor.btn')}
        sx={{ height: '40px', zIndex: 99999 }}
        variant={'outlined'}
      />
    </>
  );
};
const SubscriptionPlans = ({ subplans, selectedValue }) => {
  const getGradientDirection = (index) => {
    if (index === 0) return 'BOTTOM_LEFT';
    if (index === 1) return 'TOP_LEFT';
    return 'BOTTOM_RIGHT';
  };
  return (
    <>
      {subplans?.map((subscription, index) => (
        <CardPrincing
          key={index}
          sx={{
            ...gradientBoxStyleWithHoverAnimation(getGradientDirection(index)),
            width: ['100%', '30%'],
          }}
        >
          {subscription.code == 'ENTERPRISE' ? (
            <EnterpriseHeader subscription={subscription} />
          ) : (
            <>
              <HeaderCard>
                <Typography
                  fontWeight={900}
                  textTransform={'none'}
                  sx={{
                    color: saasModernTheme.colors.black,
                    fontSize: '24px',
                  }}
                >
                  {subscription.name}
                </Typography>
                {['PRO', 'TEAM_STARTER', 'TEAM_STARTER_ANNUAL'].includes(
                  subscription.code,
                ) && (
                  <STGradiantChip
                    disabled
                    variant="outlined"
                    label={'Popular'}
                    sx={{
                      fontSize: '14px',
                      fontWeight: '700',
                      height: '24px',
                      ml: 'auto',
                      color: saasModernTheme.colors.black,
                      textTransform: 'uppercase',
                    }}
                  />
                )}
              </HeaderCard>
              <Box
                component="div"
                sx={{
                  fontWeight: '700',
                  display: 'flex',
                  width: '100%',
                  minHeight: 40,
                  gap: 6,
                  my: 2,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: 36,
                    fontWeight: 700,
                    transform: 'scale(1.5, 1.8)',
                    display: 'inline-block',
                    color: saasModernTheme.colors.black,
                    transformOrigin: 'left center',
                    letterSpacing: saasModernTheme.letterSpacings.normal,
                  }}
                >
                  €{subscription.priceToCompare}
                </Typography>
                <PriceDisplay plan={subscription} />
              </Box>
              {subscription.code !== 'FREE' && (
                <STGradiantButton
                  fullWidth
                  href="https://app.swiftask.ai"
                  size="small"
                  label={subscription.landingPageCTA || 'Get started'}
                  sx={{ height: '40px', zIndex: 99999 }}
                  variant={index === 1 ? 'contained' : 'outlined'}
                />
              )}
            </>
          )}
          <Typography
            size="14px"
            textTransform={'none'}
            color={saasModernTheme.colors.black}
          >
            {subscription.subscriptionPlanDetails?.title}
          </Typography>
          <ListPlan>
            {subscription.subscriptionPlanDetails?.includeItems?.map(
              (content, idx) => (
                <ListPlanContent key={idx}>
                  <ContentIconListPlan>
                    <CheckIcon sx={{ color: saasModernTheme.colors.black }} />
                  </ContentIconListPlan>
                  <Typography
                    as="div"
                    textTransform="lowercase"
                    fontWeight={500}
                    size="14px"
                    sx={
                      idx < 3
                        ? {
                            background: 'transparent',
                            backgroundImage:
                              'linear-gradient(88.69deg, #1098F7 0%, #FF6E72 55.44%, #F6AE2D 100.39%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                          }
                        : {
                            color: saasModernTheme.colors.black,
                          }
                    }
                  >
                    {content}
                  </Typography>
                </ListPlanContent>
              ),
            )}
            {subscription.subscriptionPlanDetails?.notIncludeItems?.map(
              (content, idx) => (
                <ListPlanContent key={idx}>
                  <ContentIconListPlan>
                    <CloseIcon sx={{ color: 'gray' }} />
                  </ContentIconListPlan>
                  <Typography
                    as="div"
                    textTransform="lowercase"
                    fontWeight={500}
                    size="14px"
                    sx={{ color: saasModernTheme.colors.black }}
                  >
                    {content}
                  </Typography>
                </ListPlanContent>
              ),
            )}
          </ListPlan>
        </CardPrincing>
      ))}
    </>
  );
};
export default SubscriptionPlans;
